export const getFileNameFromHeader = (headerValue: string): string => {
    let output = 'defaultConvertedPackageName';
    if (!headerValue) return output;
    const sections = headerValue.split(";");
    if (sections.length < 2) return output;
    const sectionArray = sections[1].split("=");
    if (sectionArray.length < 2) return output;
    return sectionArray[1];
};